(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avantapres"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.ba-slider__range');
        if (!this.range) return;
        this.update = this.update.bind(this);
        this.range.addEventListener('input', this.update);
        this.update();
      }

      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.update);
      }

      update() {
        this.style.setProperty('--ba-position', `${this.range.value}%`);
      }
    }

    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collec"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trekward-collection')) {
  customElements.define('trekward-collection', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      if (this.dataset.bestDefault === 'true' && this.dataset.pageType === 'collection' && this.dataset.editor !== 'true') {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('sort_by') && this.dataset.currentSort !== 'best-selling') {
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.delete('page');
          window.location.replace(url.toString());
          return;
        }
      }
      const dialog = this.querySelector('.twc__dialog');
      const form = this.querySelector('.twc__filter-form');
      const sidebar = this.querySelector('.twc__sidebar');
      if (!dialog || !form || !sidebar) return;
      this.setAttribute('data-ready', '');
      const opener = this.querySelector('.twc__filter-open');
      opener.addEventListener('click', () => {
        dialog.querySelector('.twc__dialog-body').append(form);
        dialog.showModal();
      }, {signal});
      dialog.addEventListener('close', () => { sidebar.append(form); opener.focus(); }, {signal});
      this.querySelector('.twc__filter-close').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => { if(event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right) dialog.close(); } }, {signal});
      this._media = matchMedia('(min-width: 750px)');
      this._media.addEventListener('change', e => { if(e.matches && dialog.open) dialog.close(); }, {signal});
      this.querySelector('.twc__sort select').addEventListener('change', () => form.requestSubmit(), {signal});
      form.addEventListener('submit', event => {
        const nums = [...form.querySelectorAll('input[type="number"]')];
        if(nums.length === 2 && nums.every(n => n.value !== '') && Number(nums[0].value) > Number(nums[1].value)) {
          event.preventDefault();
          const previous = nums[0].value; nums[0].value = nums[1].value; nums[1].value = previous;
          form.requestSubmit();
        }
      }, {signal});
      this.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        const rail = this.querySelector('.twc__rail');
        rail.scrollBy({left: Number(button.dataset.railStep) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.querySelectorAll('.twc__image-toggle').forEach(button => button.addEventListener('click', () => {
        const media = button.closest('.twc__media');
        const second = media.toggleAttribute('data-second');
        button.setAttribute('aria-pressed', String(second));
      }, {signal}));
    }
    disconnectedCallback() { this._controller?.abort(); this._controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collectionfix"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('trekward-collection')) {
  customElements.define('trekward-collection', class extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      if (this.dataset.bestDefault === 'true' && this.dataset.pageType === 'collection' && this.dataset.editor !== 'true') {
        const url = new URL(window.location.href);
        if (!url.searchParams.has('sort_by') && this.dataset.currentSort !== 'best-selling') {
          url.searchParams.set('sort_by', 'best-selling');
          url.searchParams.delete('page');
          window.location.replace(url.toString());
          return;
        }
      }
      const dialog = this.querySelector('.twc__dialog');
      const form = this.querySelector('.twc__filter-form');
      const sidebar = this.querySelector('.twc__sidebar');
      if (!dialog || !form || !sidebar) return;
      this.setAttribute('data-ready', '');
      const opener = this.querySelector('.twc__filter-open');
      opener.addEventListener('click', () => {
        dialog.querySelector('.twc__dialog-body').append(form);
        dialog.showModal();
      }, {signal});
      dialog.addEventListener('close', () => { sidebar.append(form); opener.focus(); }, {signal});
      this.querySelector('.twc__filter-close').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => { if(event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right) dialog.close(); } }, {signal});
      this._media = matchMedia('(min-width: 750px)');
      this._media.addEventListener('change', e => { if(e.matches && dialog.open) dialog.close(); }, {signal});
      this.querySelector('.twc__sort select').addEventListener('change', () => form.requestSubmit(), {signal});
      form.addEventListener('submit', event => {
        const nums = [...form.querySelectorAll('input[type="number"]')];
        if(nums.length === 2 && nums.every(n => n.value !== '') && Number(nums[0].value) > Number(nums[1].value)) {
          event.preventDefault();
          const previous = nums[0].value; nums[0].value = nums[1].value; nums[1].value = previous;
          form.requestSubmit();
        }
      }, {signal});
      this.querySelectorAll('[data-rail-step]').forEach(button => button.addEventListener('click', () => {
        const rail = this.querySelector('.twc__rail');
        rail.scrollBy({left: Number(button.dataset.railStep) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal}));
      this.querySelectorAll('.twc__image-toggle').forEach(button => button.addEventListener('click', () => {
        const media = button.closest('.twc__media');
        const second = media.toggleAttribute('data-second');
        button.setAttribute('aria-pressed', String(second));
      }, {signal}));
    }
    disconnectedCallback() { this._controller?.abort(); this._controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('infos-defilantes')) {
    customElements.define('infos-defilantes', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
          const paused = this.toggleAttribute('data-paused');
          button.setAttribute('aria-pressed', String(paused));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustcar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const viewport = root.querySelector('.osif-reviews__viewport');
      const cards = [...root.querySelectorAll('.osif-review')];
      const prev = root.querySelector('.osif-reviews__arrow--prev');
      const next = root.querySelector('.osif-reviews__arrow--next');
      const dots = root.querySelector('.osif-reviews__dots');
      if (!viewport || !cards.length) return;
      let index = 0;
      let timer;
      cards.forEach((card, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'osif-reviews__dot';
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        dots.appendChild(dot);
      });
      const dotItems = [...dots.children];
      const maxIndex = () => {
        const cardWidth = cards[0].getBoundingClientRect().width;
        return Math.max(0, Math.round((viewport.scrollWidth - viewport.clientWidth) / cardWidth));
      };
      const update = () => {
        const left = viewport.scrollLeft;
        index = cards.reduce((best, card, i) => Math.abs(card.offsetLeft - left) < Math.abs(cards[best].offsetLeft - left) ? i : best, 0);
        dotItems.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        const loop = root.dataset.loop === 'true';
        prev.disabled = !loop && index === 0;
        next.disabled = !loop && index >= maxIndex();
      };
      const goTo = (target) => {
        const last = maxIndex();
        let chosen = target;
        if (root.dataset.loop === 'true') {
          if (chosen < 0) chosen = last;
          if (chosen > last) chosen = 0;
        } else chosen = Math.max(0, Math.min(chosen, last));
        viewport.scrollTo({ left: cards[chosen].offsetLeft, behavior: 'smooth' });
      };
      const stop = () => window.clearInterval(timer);
      const play = () => {
        stop();
        if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => goTo(index + 1), Number(root.dataset.speed));
      };
      prev.addEventListener('click', () => goTo(index - 1));
      next.addEventListener('click', () => goTo(index + 1));
      viewport.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);
      window.addEventListener('resize', update);
      update();
      play();
    };
    document.querySelectorAll('.osif-reviews').forEach(initialise);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target.querySelector('.osif-reviews')));
  })();

  } catch(e) { console.error(e); }
})();
})();
